<script setup>
import { useInactivityLogout } from '../composables/useInactivityLogout';

const { showWarning, countdown, stayLoggedIn, doLogout } =
  useInactivityLogout();
</script>

<template>
  <teleport to="body">
    <div
      v-if="showWarning"
      class="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50"
    >
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-8">
        <h2 class="text-xl font-semibold text-gray-900 mb-2">
          {{ $t('ARDHISASA.INACTIVITY.TITLE') }}
        </h2>
        <p class="text-gray-600 mb-6">
          {{ $t('ARDHISASA.INACTIVITY.MESSAGE', { seconds: countdown }) }}
        </p>
        <div class="flex gap-3 justify-end">
          <button
            class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-red-600 hover:bg-red-700 transition-colors"
            @click="doLogout"
          >
            {{ $t('ARDHISASA.INACTIVITY.LOGOUT_NOW') }}
          </button>
          <button
            class="px-4 py-2 rounded-lg text-sm font-medium text-white bg-[#71481d] hover:bg-[#5a3a17] transition-colors"
            @click="stayLoggedIn"
          >
            {{ $t('ARDHISASA.INACTIVITY.STAY_LOGGED_IN') }}
          </button>
        </div>
      </div>
    </div>
  </teleport>
</template>
